<style lang="scss">

</style>
<!--eslint-disable-->
<template>
  <div class="issues-page">
    <b-card no-body class="mb-0 mt-4">
      <div class="card-header">
        <div>
          <h4 class="card-title">Issues</h4>
        </div>
      </div>
      <section>
        <b-table
          class="data-table"
          hover
          :items="issues"
          :fields="headers"
          :current-page="currentPage"
          :per-page="0"
        >
          <template #cell(subject)="data">
            <router-link :to="{ name: 'issue-view', params: { uid: data.item.uid } }" class="font-weight-bold d-block text-nowrap text-underline">
              {{ data.item.target_name }} {{data.item.subject }}
            </router-link>
          </template>
          <template #cell(status)="data">
          <span class="badge badge-pill"
                :class="{
              'badge-primary' : data.item.closed === true,
              'badge-warning' : data.item.closed === false,
            }">{{ data.item.closed === false ? 'Open' : 'Closed' }}</span>
          </template>
          <template #cell(issue_type)="data">
            {{data.item.issue_type }}
          </template>
          <template #cell(severity)="data">
            <span class="badge badge-pill"
                  :class="{
              'badge-primary' : data.item.severity === 'LOW',
              'badge-warning' : data.item.severity === 'MEDIUM',
              'badge-danger' : data.item.severity === 'HIGH',
              'badge-dark' : data.item.severity === 'CRITICAL',
            }">
              {{data.item.severity}}
            </span>
          </template>
          <template #cell(status)="data">
            <span class="badge badge-pill"
                  :class="{
              'badge-danger' : data.item.status === 'open',
              'badge-warning' : data.item.status === 'ignored',
              'badge-success' : data.item.status === 'closed',
            }">
              {{data.item.status}}
            </span>
          </template>
          <template #cell(actions)="data">
            <b-dropdown class="m-0"  variant="link" right toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <i class="fas fa-ellipsis-v"></i>
              </template>
              <b-dropdown-item-button class="full-nested-btn" v-if="$can('Update', 'Issue')"
                                      @refresh="refreshIssues()" @click="showIssueModal(data.item, 'modal-update-issue')">
                Update Issue
              </b-dropdown-item-button>
            </b-dropdown>
          </template>
        </b-table>
        <b-row>
          <b-col md="6" class="my-1" v-if="total_count > filters.page_size">
            <b-pagination @change="getMoreIssues" :total-rows="total_count" :per-page="10" v-model="currentPage" class="my-0"/>
          </b-col>
          <b-col class="ml-2 mt-1" v-if="total_count === 0">
            <p >No results</p>
          </b-col>
        </b-row>
      </section>
    </b-card>
    <b-modal id="modal-update-issue" title="Update issue" size="lg" hide-footer>
      <update-issue v-if="selectedIssue" :uid="selectedIssue.uid" :issue-existing="selectedIssue"  @refresh="refreshIssues()" @close="closeModals()"></update-issue>
    </b-modal>

  </div>
</template>
<!--eslint-enable-->

<script>
import { BPagination } from 'bootstrap-vue'
import TargetService from '@/services/TargetService'
import UpdateIssue from '../views/issues/sections/UpdateIssue.vue';
import IssueService from '../services/IssueService';

export default {
  name: 'Issues',
  components: {
    BPagination,
    UpdateIssue,
  },
  props: {
    uid: {
      required: true,
      type: String,
    },
    type: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      selectedTarget: null,
      selectedIssue: null,
      headers: [
        {
          key: 'subject',
          label: 'Subject',
        },
        {
          key: 'severity',
          label: 'Severity',
        },
        {
          key: 'status',
          label: 'Status',
        },
        {
          key: 'issue_type',
          label: 'Type',
        },
        {
          key: 'actions',
          label: 'Actions',
          class: 'text-right',
        },
      ],
      target: {},
      issues: [],
      currentPage: 1,
      filters: {
        page: 0,
        page_size: 10,
      },
      total_count: 0,
    };
  },
  mounted() {
    this.getTarget();
    this.getIssues();
  },
  methods: {
    refreshIssues() {
      this.closeModals();
      this.getIssues();
    },
    closeModals() {
      this.$bvModal.hide('modal-add-target');
      this.$bvModal.hide('modal-delete-target');
      this.$bvModal.hide('modal-update-target');
      this.$bvModal.hide('modal-delete-modal');
    },
    getTarget() {
      this.loading = true;
      TargetService.getTarget(this.uid).then(res => {
        this.target = res.data;
        this.getIssues();
      }).catch(() => {
        this.$toast.error('Could not get target, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    getMoreIssues(val) {
      this.filters.page = val - 1; // api index starts at 0, bootstrap starts at Notification Group1 lol
      this.getIssues();
    },
    showIssueModal(issue, modalName) {
      this.setSelectedIssue(issue);
      this.$bvModal.show(modalName);
    },
    getIssues() {
      if (this.type === 'target') {
        IssueService.getTargetIssues(this.uid, this.filters).then(res => {
          this.issues = res.data.data;
          this.issues.page = res.data.meta.page;
          this.currentPage = res.data.meta.page + 1;
          this.issues.page_size = 10;
          this.total_count = res.data.meta.total_count;
        }).catch(() => {
          this.$toast.error('Could not get issues, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      }
    },
    clearFilters() {
      this.filters = {
        page: 0,
        page_size: 10,
        search: '',
      };

      this.getMoreIssues(1);
    },
    setSelectedIssue(issue) {
      this.selectedIssue = issue;
    },
  },
};
</script>
